<template>

  <a
    href="javascript:void(0)"
    class="list-group-item list-group-item-action"
    @click="showCandidate(value._id)">
    <div class="photo">
      <Avatar
        :src="imgSrc"
        :name="value.name"
        size="40px"
        radius="5px"
        resize="100x100x1" />
    </div>
    <div class="name">
      {{ value.name }}
    </div>
  </a>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'SearchItem',
  components: {
    Avatar
  },
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  computed: {
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.value.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    showCandidate (id) {
      this.$emit('showCandidate', id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  padding: 5px;
  display: flex;
  align-items: center;
}
  a > .photo{
    min-width: 40px;
    min-height: 40px;
    flex: 0;
    margin-right: 5px;
  }
  a > .name{
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/CandidateQuickSearch/CandidateQuickSearchItem.vue